function formatCurrency (value) {
  if (typeof value === 'undefined' || value === null) {
    return ''
  }

  value = String(value).replace(/[^0-9]/g, '')

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0
  })

  return `Rp${formatter.format(parseInt(value))}`
}

export {
  formatCurrency
}
